/* eslint-disable no-underscore-dangle */

/**
 * Funções utilitarias para as implementações de medidas
 */

/**
 * Handles the init hook for polylines and circles.
 * Implements the showOnHover functionality if called for.
 */
export const addInitHook = function () {
  var showOnHover =
    this.options.measurementOptions &&
    this.options.measurementOptions.showOnHover;
  if (this.options.showMeasurements && !showOnHover) {
    this.showMeasurements();
  }
  if (this.options.showMeasurements && showOnHover) {
    this.on('mouseover', function () {
      this.showMeasurements();
    });
    this.on('mouseout', function () {
      this.hideMeasurements();
    });
  }
};

/**
 * Função que faz uma especie de merge, recebendo como parametro
 * a função nativa, e uma função 'customizada'. E em vez de fazer um
 * override como o nome sugere, ele apenas executa as duas funções, e retorna
 * o valor da nativa, ou  da 'customizada', dependendo do parâmetro `hookAfter`
 * @param {Function} method Função ou método nativo
 * @param {Function} fn Função customizada
 * @param {Boolean} hookAfter Determina se a `fn` deve ser executada antes ou  depois da nativa
 */
export const override = function (method, fn, hookAfter) {
  if (!hookAfter) {
    return function () {
      var originalReturnValue = method.apply(this, arguments);
      var args = Array.prototype.slice.call(arguments);
      args.push(originalReturnValue);
      return fn.apply(this, args);
    };
  } else {
    return function () {
      fn.apply(this, arguments);
      return method.apply(this, arguments);
    };
  }
};
